import script from "./DocSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./DocSidebar.vue?vue&type=script&setup=true&lang=js"

import "./DocSidebar.vue?vue&type=style&index=0&id=ab34f54a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab34f54a"]])

export default __exports__